export const CUSTOMER_KEY_OSCAR = "oscar";
export const CUSTOMER_KEY_THE_STUDENT_HOTEL = "theStudentHotel";
export const CUSTOMER_KEY_TELEFONICA = "telefonica";

export default {
  [CUSTOMER_KEY_OSCAR]: {
    companyName: "Oscar",
    name: "Stefana Muller",
    jobDescription: "Senior Director, CTO Product and Program Office",
    quote: "monday.com Work OS saves us about 1,850 hrs of staff time and somewhere in the range of $50,000 a month."
  },
  [CUSTOMER_KEY_THE_STUDENT_HOTEL]: {
    companyName: "The Student Hotel",
    name: "Charlie MacGregor",
    jobDescription: "Founder & CEO",
    quote:
      "Now that we have monday.com Work OS as the backbone of our organization I feel that I have an overview I can trust."
  },
  [CUSTOMER_KEY_TELEFONICA]: {
    companyName: "Telefonica",
    name: "Tye Rapley-Hawkins",
    jobDescription: "Head of Delivery",
    quote:
      "With monday.com, we’re 30% more efficient at delivering hundreds of campaigns seen by millions of customers."
  }
};
